<template>
    <div class="news-tag">Negócios</div>
</template>

<script>
export default {
    name: 'tag'
}
</script>

<style lang="scss" scoped>
.news-tag {
    @apply w-20 flex items-center justify-center bg-primary p-2 text-xs text-white rounded-md;
}
</style>
